<template>
  <default-layout>
    <event-navbar title="Meetings" />
    <meeting-list />
  </default-layout>
</template>

<script>
import MeetingList from '@/components/speaker/meeting-list.vue'
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'

export default {
  name: 'MeetingListView',
  components: { MeetingList, EventNavbar, DefaultLayout },
}
</script>
